<div class="header">
    <div class="header-top">
        <div class="container">
            <div class="col-sm-6 header-logo">
                <a class="navbar-brand"  routerLink="landing" href="#">
                    <img src="../../../../../../assets/images/logo1.png" alt="" class="">
                </a>
            </div> 
                           
        </div>
    </div>
    <div class="header-bottom">
        <nav class="navbar navbar-expand-sm navbar-dark bg-light">
            
        </nav>
    </div>
   

</div>